import services from "../services";
import * as types from "./mutation-type";

export const ActionSetAddress = ({commit}, payload) => {
    commit(types.SET_ADDRESS, payload)
}

export const  ActionGetAllAddress = async ({_})  => {   
    const { data } = await services.getAllAddress()
    if(data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}

export const ActionGetAddress = async ({_}, payload) => {
    const { data } = await services.getAddress(payload)
    if (data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}

export const ActionCreate = async ({_}, payload) => {   
    const { data } = await services.create(payload)
    if (data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}

export const ActionUpdateAddress = async ({commit}, payload) => {
    const { data } = await services.update(payload);
    if (data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}

export const ActionSetMain = async ({_}, payload) => {
    const { data } = await services.setMain(payload);
    if (data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}

export const ActionSetMainAddress = ({commit}, payload) => {
    commit(types.SET_MAIN_ADDRESS, payload)
}

export const ActionGetMainAddress = async () => {
    const { data } = await services.getMainAddress()
    if(data.error === false) {
        return Promise.resolve(data)
    }
    return Promise.reject(data)
}

